import Splash from 'Pages/Splash';
import SecureDownload from 'Pages/SecureDownload';

export default [
    //{ path: '/', component: Splash, guards: ['guest'] },
    { path: '/secure-download/:id', component: SecureDownload },
];
